import React from "react";
import { EvalPaneTemplates as EvalPaneTemplatesShared } from "../../../shared/EvalPaneTemplates";
import { EvalPaneTemplate } from "../Types";

// https://github.com/rjsf-team/react-jsonschema-form/blob/23937978b46ac8373994851d99914be83e6969b7/packages/core/src/components/fields/ObjectField.js#L13
function OneOfFieldTemplate(props: any) {
  if (props.schema.oneOf === undefined) {
    return props.properties.map((prop: any) => prop.content);
  }
  const { TitleField, DescriptionField } = props;
  return (
    <fieldset id={props.idSchema.$id}>
      {(props.uiSchema["ui:title"] || props.title) && (
        <TitleField
          id={`${props.idSchema.$id}__title`}
          title={props.title || props.uiSchema["ui:title"]}
          required={props.required}
          formContext={props.formContext}
        />
      )}
      {props.description && (
        <DescriptionField
          id={`${props.idSchema.$id}__description`}
          description={props.description}
          formContext={props.formContext}
        />
      )}
      {props.properties.map((prop: any) => prop.content)}
      {/*canExpand(props.schema, props.uiSchema, props.formData) && (
        <AddButton
          className="object-property-expand"
          onClick={props.onAddClick(props.schema)}
          disabled={props.disabled || props.readonly}
        />
      )*/}
    </fieldset>
  );
}

export const EvalPaneTemplates: Record<string, EvalPaneTemplate> = {
  ...EvalPaneTemplatesShared,
  dwfGSsdnSSDY0lUUj3LtH: {
    ...EvalPaneTemplatesShared["dwfGSsdnSSDY0lUUj3LtH"],
    uiSchema: {
      x: {
        "ui:ObjectFieldTemplate": OneOfFieldTemplate,
      },
      y: {
        "ui:ObjectFieldTemplate": OneOfFieldTemplate,
      },
    },
  },
};
